import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b699fa6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border border-neutral-200 rounded-lg overflow-hidden" }
const _hoisted_2 = { class: "trayek-group" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm text-neutral-800" }, "Transaksi Kupon BBM (Tanpa Trayek)", -1))
const _hoisted_5 = {
  key: 0,
  class: "trayek-content bg-neutral-50 border-b border-neutral-200"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center p-4" }, "Tidak ada data transaksi.", -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lihat Detail", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "mt-4 flex justify-center pb-4"
}
const _hoisted_12 = {
  key: 0,
  class: "p-6 text-center text-neutral-400"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner text-2xl" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm" }, "Memuat data trayek...", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex items-center gap-3" }
const _hoisted_18 = { class: "font-bold text-sm" }
const _hoisted_19 = {
  class: "normal-liter-info",
  style: {"display":"flex","align-items":"center","justify-content":"space-between","width":"160px","min-width":"160px"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "normal-liter-label",
  style: {"white-space":"nowrap"}
}, "Normal Liter:", -1))
const _hoisted_21 = {
  class: "normal-liter-value",
  style: {"font-weight":"700","color":"#16a34a","text-align":"right","margin-left":"8px","white-space":"nowrap"}
}
const _hoisted_22 = {
  key: 0,
  class: "trayek-content bg-neutral-50 border-b border-neutral-200"
}
const _hoisted_23 = {
  key: 0,
  class: "p-6 text-center text-neutral-400"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner text-xl" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm" }, "Memuat transaksi PP...", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "p-6 text-center text-neutral-400"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-inbox text-2xl" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm" }, "Tidak ada transaksi PP untuk trayek ini.", -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "pp-row-content flex items-center justify-between w-full" }
const _hoisted_32 = { class: "flex flex-col gap-1" }
const _hoisted_33 = { class: "flex items-center gap-2" }
const _hoisted_34 = { class: "font-bold text-neutral-800 text-sm" }
const _hoisted_35 = { class: "flex items-center gap-4" }
const _hoisted_36 = { class: "flex items-center gap-1 text-xs text-neutral-500" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-neutral-400" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kru:", -1))
const _hoisted_39 = { class: "font-semibold text-neutral-700" }
const _hoisted_40 = { class: "flex items-center gap-1 text-xs text-neutral-500" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-car text-neutral-400" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nopol:", -1))
const _hoisted_43 = { class: "font-semibold text-neutral-700" }
const _hoisted_44 = { class: "flex items-center gap-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-box text-neutral-400 text-xs" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-700" }, " Total Pengisian: ", -1))
const _hoisted_47 = { class: "p-0" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lihat Detail", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = {
  key: 0,
  class: "mt-2 flex justify-center pb-4"
}
const _hoisted_53 = { class: "mt-4 flex justify-center" }

import { PropType } from 'vue'
import moment from 'moment'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Paginator from '@/views/components/paginator/Paginator.vue'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import { ITrayek, IFuelTransactionListItem } from '@/utils/interfaces/iFuelMonitoring'
import { useApprovalStatus } from '@/composables/useApprovalStatus'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionTables',
  props: {
  // Level 1 - Trayek
  trayekList: {
    type: Array as PropType<ITrayek[]>,
    default: () => []
  },
  isLoadingTrayeks: {
    type: Boolean,
    default: false
  },
  expandedTrayekIds: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  trayekPaginate: {
    type: Object,
    required: true
  },

  // Level 2 - PP Transactions per trayek
  trayekTransactions: {
    type: Object as PropType<Record<string, IFuelTransactionListItem[]>>,
    default: () => ({})
  },
  trayekTransactionLoading: {
    type: Object as PropType<Record<string, boolean>>,
    default: () => ({})
  },
  trayekTransactionPaginate: {
    type: Object as PropType<Record<string, { pageSize: number; pageNumber: number; totalRecords: number }>>,
    default: () => ({})
  },

  // Level 3 - Expanded PP rows
  expandedPpRows: {
    type: Object as PropType<Record<string, any[]>>,
    default: () => ({})
  },

  // Non-PP (unchanged)
  transactionNonPpRowData: {
    type: Array,
    default: () => []
  },
  expandedTransactionNonPpRows: {
    type: Array,
    default: () => []
  },
  transactionNonPpList: {
    type: Array,
    default: () => []
  },
  isLoadingTransactionNonPp: {
    type: Boolean,
    default: false
  },
  transactionNonPpPaginate: {
    type: Object,
    required: true
  },

  // Utils
  getStatusLabel: {
    type: Function as PropType<(status?: string) => string>,
    required: true
  }
},
  emits: [
  'expandTrayek',
  'changeTrayekPage',
  'changePpPage',
  'expandPpRow',
  'expandedTransactionNonPpRowsChange',
  'onChangeTransactionNonPpPage',
  'openDetail'
],
  setup(__props, { emit }) {

const props = __props

const { getDynamicStatusColor, getDynamicStatusText, getDynamicStatusBg } = useApprovalStatus()





const toggleNonPpExpansion = () => {
  const isExpanded = props.expandedTransactionNonPpRows && props.expandedTransactionNonPpRows.length > 0
  if (isExpanded) {
    emit('expandedTransactionNonPpRowsChange', [])
  } else {
    emit('expandedTransactionNonPpRowsChange', props.transactionNonPpRowData)
  }
}

const getStatusBadgeClass = (status?: string) => {
  switch (status) {
    case 'Under': return 'status-badge-under'
    case 'Normal': return 'status-badge-normal'
    case 'Warning': return 'status-badge-warning'
    case 'Over': return 'status-badge-over'
    default: return 'status-badge-default'
  }
}

const getStatusColor = (status?: string) => {
  switch (status) {
    case 'Under': return '#F59E0B'
    case 'Normal': return '#22C55E'
    case 'Warning': return '#F97316'
    case 'Over': return '#EF4444'
    default: return '#262626'
  }
}

const getTransactionTypeText = (type?: string) => {
  if (!type) return '-'
  switch (type) {
    case 'ScanHjCrew': return 'Scan Kru HJ'
    case 'Voucher': return 'Kupon BBM'
    case 'Refund': return 'Refund'
    default: return type
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "trayek-header flex items-center justify-between px-4 py-3 cursor-pointer select-none border-b border-neutral-200 transition-colors bg-yellow-header",
          onClick: toggleNonPpExpansion
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("i", {
              class: _normalizeClass(["pi text-sm text-neutral-800", (__props.expandedTransactionNonPpRows && __props.expandedTransactionNonPpRows.length > 0) ? 'pi-chevron-down' : 'pi-chevron-right'])
            }, null, 2),
            _hoisted_4
          ])
        ]),
        (__props.expandedTransactionNonPpRows && __props.expandedTransactionNonPpRows.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(DataTable), {
                value: __props.transactionNonPpList,
                dataKey: "Id",
                responsiveLayout: "scroll",
                class: "excel-clone",
                loading: __props.isLoadingTransactionNonPp
              }, {
                empty: _withCtx(() => [
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(Column), {
                    field: "CreatedAt",
                    header: "TANGGAL & WAKTU",
                    alignHeader: "center"
                  }, {
                    body: _withCtx((innerProps) => [
                      _createTextVNode(_toDisplayString(innerProps.data.CreatedAt ? _unref(moment)(innerProps.data.CreatedAt).format('DD/MM/YYYY - HH:mm:ss') : '-'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Column), {
                    field: "Code",
                    header: "KODE",
                    alignHeader: "center",
                    headerStyle: "width: 120px",
                    bodyStyle: "width: 120px"
                  }),
                  _createVNode(_unref(Column), {
                    field: "FuelStationPartnerName",
                    header: "POM MITRA",
                    alignHeader: "center"
                  }, {
                    body: _withCtx((innerProps) => [
                      _createTextVNode(_toDisplayString(innerProps.data.FuelStationPartnerName || '-'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Column), {
                    field: "TransactionType",
                    header: "JENIS TRANSAKSI",
                    alignHeader: "center"
                  }, {
                    body: _withCtx((innerProps) => [
                      _createTextVNode(_toDisplayString(getTransactionTypeText(innerProps.data.TransactionType)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Column), {
                    field: "Liters",
                    header: "PEMBELIAN",
                    alignHeader: "center",
                    headerStyle: "width: 100px",
                    bodyStyle: "width: 100px"
                  }, {
                    body: _withCtx((innerProps) => [
                      _createTextVNode(_toDisplayString(innerProps.data.Liters) + " L ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Column), {
                    field: "Price",
                    header: "NOMINAL",
                    alignHeader: "center"
                  }, {
                    body: _withCtx((innerProps) => [
                      _createTextVNode(_toDisplayString(_unref(rupiahFormat)(innerProps.data.Price)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Column), {
                    field: "ApprovalStatus",
                    header: "STATUS",
                    alignHeader: "center"
                  }, {
                    body: _withCtx((innerProps) => [
                      _createElementVNode("span", {
                        class: "inline-block text-center leading-tight border rounded px-2 py-1 text-xs",
                        style: _normalizeStyle({
                color: _unref(getDynamicStatusColor)(innerProps.data.ApprovalStatus),
                borderColor: _unref(getDynamicStatusColor)(innerProps.data.ApprovalStatus),
                backgroundColor: _unref(getDynamicStatusBg)(innerProps.data.ApprovalStatus)
              })
                      }, _toDisplayString(_unref(getDynamicStatusText)(innerProps.data.ApprovalStatus)), 5)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Column), {
                    header: "AKSI",
                    alignHeader: "center"
                  }, {
                    body: _withCtx((innerProps) => [
                      _createElementVNode("a", {
                        href: "#",
                        class: "btn-detail",
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('openDetail', innerProps.data)), ["prevent"])
                      }, _hoisted_10, 8, _hoisted_7)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "loading"]),
              (__props.transactionNonPpPaginate.totalRecords > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(Paginator, {
                      first: ((__props.transactionNonPpPaginate.pageNumber || 1) - 1) * (__props.transactionNonPpPaginate.pageSize || 10),
                      rows: __props.transactionNonPpPaginate.pageSize,
                      totalRecords: __props.transactionNonPpPaginate.totalRecords,
                      onOnPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChangeTransactionNonPpPage', $event)))
                    }, null, 8, ["first", "rows", "totalRecords"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (__props.isLoadingTrayeks && __props.trayekList.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.trayekList, (trayek) => {
        return (_openBlock(), _createElementBlock("div", {
          key: trayek.Id,
          class: "trayek-group"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["trayek-header flex items-center justify-between px-4 py-3 cursor-pointer select-none border-b border-neutral-200 hover:bg-neutral-50 transition-colors", { 'trayek-header-expanded': __props.expandedTrayekIds.includes(trayek.Id) }]),
            onClick: ($event: any) => (_ctx.$emit('expandTrayek', trayek.Id))
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("i", {
                class: _normalizeClass(["pi text-sm", __props.expandedTrayekIds.includes(trayek.Id) ? 'pi-chevron-down' : 'pi-chevron-right'])
              }, null, 2),
              _createElementVNode("span", _hoisted_18, _toDisplayString(trayek.Name), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("span", _hoisted_21, _toDisplayString(trayek.EstimatedFuelConsumptionLiters) + " L", 1)
            ])
          ], 10, _hoisted_16),
          (__props.expandedTrayekIds.includes(trayek.Id))
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (__props.trayekTransactionLoading[trayek.Id])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                  : (!__props.trayekTransactions[trayek.Id] || __props.trayekTransactions[trayek.Id].length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_30))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createVNode(_unref(DataTable), {
                          value: __props.trayekTransactions[trayek.Id],
                          dataKey: "Id",
                          responsiveLayout: "scroll",
                          class: "outer-table pp-table",
                          showHeader: false,
                          expandedRows: __props.expandedPpRows[trayek.Id] || [],
                          "onUpdate:expandedRows": ($event: any) => (_ctx.$emit('expandPpRow', trayek.Id, $event))
                        }, {
                          expansion: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_47, [
                              _createVNode(_unref(DataTable), {
                                value: slotProps.data.FuelingTransactions,
                                dataKey: "Id",
                                responsiveLayout: "scroll",
                                class: "excel-clone"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Column), {
                                    field: "CreatedAt",
                                    header: "TANGGAL & WAKTU",
                                    alignHeader: "center"
                                  }, {
                                    body: _withCtx((innerProps) => [
                                      _createTextVNode(_toDisplayString(_unref(moment)(innerProps.data.CreatedAt).format('DD/MM/YYYY - HH:mm:ss')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(Column), {
                                    field: "Code",
                                    header: "KODE",
                                    alignHeader: "center",
                                    headerStyle: "width: 120px",
                                    bodyStyle: "width: 120px"
                                  }),
                                  _createVNode(_unref(Column), {
                                    field: "FuelStationPartnerName",
                                    header: "POM MITRA",
                                    alignHeader: "center"
                                  }),
                                  _createVNode(_unref(Column), {
                                    field: "TransactionType",
                                    header: "JENIS TRANSAKSI",
                                    alignHeader: "center"
                                  }, {
                                    body: _withCtx((innerProps) => [
                                      _createTextVNode(_toDisplayString(getTransactionTypeText(innerProps.data.TransactionType)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(Column), {
                                    field: "Liters",
                                    header: "PEMBELIAN",
                                    alignHeader: "center",
                                    headerStyle: "width: 100px",
                                    bodyStyle: "width: 100px"
                                  }, {
                                    body: _withCtx((innerProps) => [
                                      _createTextVNode(_toDisplayString(innerProps.data.Liters) + " L ", 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(Column), {
                                    field: "Price",
                                    header: "NOMINAL",
                                    alignHeader: "center"
                                  }, {
                                    body: _withCtx((innerProps) => [
                                      _createTextVNode(_toDisplayString(_unref(rupiahFormat)(innerProps.data.Price)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(Column), {
                                    field: "ApprovalStatus",
                                    header: "STATUS",
                                    alignHeader: "center"
                                  }, {
                                    body: _withCtx((innerProps) => [
                                      _createElementVNode("span", {
                                        class: "inline-block text-center leading-tight border rounded px-2 py-1 text-xs",
                                        style: _normalizeStyle({
                        color: _unref(getDynamicStatusColor)(innerProps.data.ApprovalStatus),
                        borderColor: _unref(getDynamicStatusColor)(innerProps.data.ApprovalStatus),
                        backgroundColor: _unref(getDynamicStatusBg)(innerProps.data.ApprovalStatus)
                      })
                                      }, _toDisplayString(_unref(getDynamicStatusText)(innerProps.data.ApprovalStatus)), 5)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(Column), {
                                    header: "AKSI",
                                    alignHeader: "center"
                                  }, {
                                    body: _withCtx((innerProps) => [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: "btn-detail",
                                        onClick: _withModifiers(($event: any) => (_ctx.$emit('openDetail', innerProps.data)), ["prevent"])
                                      }, _hoisted_51, 8, _hoisted_48)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(Column), {
                              expander: "",
                              style: {"width":"3rem"}
                            }),
                            _createVNode(_unref(Column), null, {
                              body: _withCtx((slotProps) => [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("span", _hoisted_34, _toDisplayString(slotProps.data.TrxId), 1),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["pp-badge", slotProps.data.PpOrder % 2 !== 0 ? 'pp-badge-odd' : 'pp-badge-even'])
                                      }, "PP " + _toDisplayString(slotProps.data.PpOrder), 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _hoisted_37,
                                        _hoisted_38,
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(slotProps.data.CondecturName || '-'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_40, [
                                        _hoisted_41,
                                        _hoisted_42,
                                        _createElementVNode("span", _hoisted_43, _toDisplayString(slotProps.data.VehicleRegNumber || '-'), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_44, [
                                    _hoisted_45,
                                    _hoisted_46,
                                    _createElementVNode("span", {
                                      class: "font-bold text-sm",
                                      style: _normalizeStyle({ color: getStatusColor(slotProps.data.FuelUsageStatus) })
                                    }, _toDisplayString(slotProps.data.TotalFuelingLiter) + " L ", 5),
                                    (slotProps.data.FuelUsageStatusDisplayName || slotProps.data.FuelUsageStatus)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass(["status-badge", getStatusBadgeClass(slotProps.data.FuelUsageStatus)])
                                        }, _toDisplayString(slotProps.data.FuelUsageStatusDisplayName || slotProps.data.FuelUsageStatus), 3))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["value", "expandedRows", "onUpdate:expandedRows"]),
                        (__props.trayekTransactionPaginate[trayek.Id] && __props.trayekTransactionPaginate[trayek.Id].totalRecords > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createVNode(Paginator, {
                                first: ((__props.trayekTransactionPaginate[trayek.Id]?.pageNumber || 1) - 1) * (__props.trayekTransactionPaginate[trayek.Id]?.pageSize || 5),
                                rows: __props.trayekTransactionPaginate[trayek.Id].pageSize,
                                totalRecords: __props.trayekTransactionPaginate[trayek.Id].totalRecords,
                                onOnPage: ($event: any) => (_ctx.$emit('changePpPage', trayek.Id, $event))
                              }, null, 8, ["first", "rows", "totalRecords", "onOnPage"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_53, [
      (__props.trayekPaginate.totalRecords > 0)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            first: ((__props.trayekPaginate.pageNumber || 1) - 1) * (__props.trayekPaginate.pageSize || 10),
            rows: __props.trayekPaginate.pageSize,
            totalRecords: __props.trayekPaginate.totalRecords,
            onOnPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeTrayekPage', $event)))
          }, null, 8, ["first", "rows", "totalRecords"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})